import React from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from 'redux-form';
import { CallAPI } from "../../common/formsubmit";
import appConfig from "../../../config/config";
import {Loading,LoadingDone,Reset,Success,Error,SetCompanySearchResult, ShowAddCompany} from "../../../actions/loading"    
import {
  Card, CardBody,
  CardTitle, Form, Row, FormGroup, Button, Col, Input
} from 'reactstrap';
class SearchCompanyProductForm extends React.Component  
{
    constructor(props) {
        super(props);
    }
    handleSearch = (values) => {  
      console.log(values);   
        this.props.Loading();
        CallAPI(values, 
                appConfig.apiGateway.getSearchDataUrl, 
                this.props, 
                "GetCompany", 
                this.props.LoadingDone, 
                this.props.SetCompanySearchResult);
    }
    renderInput({ input, placeholder }) {
      return (
          <input {...input} className="form-control" placeholder={placeholder} />
          );
  }
    render() {
        return (
          <>
            <Card className="w-100">
              <CardBody>
                <CardTitle>Search Criteria</CardTitle>
                <form onSubmit={this.props.handleSubmit(this.handleSearch)}>
                  <Row form>
                    <Col md={2}>
                      <FormGroup>
                        <Field
                          name="CompanyName"
                          component={this.renderInput}
                          placeholder="Name"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Button color="primary">Search</Button>
                        <Button className="ml-3">Reset</Button>
                        <Button className="ml-3" onClick={()=> {
                          this.props.ShowAddCompany()
                          }
                        } >Add</Button>
                      </FormGroup>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </>
        );            
    }
}
const validate = (formvalues) => {
}
var cpf = reduxForm({
    form: 'searchCompanyProductform',
    validate
})(SearchCompanyProductForm);
cpf = connect(state => ({
    session: state.session,
    loading : state.loading
}),
{LoadingDone,Loading,Success,Error,Reset, SetCompanySearchResult, ShowAddCompany})(cpf);
export default cpf;